module.exports = __webpack_public_path__ + "static/media/ChromecastConnectingStep3Icon.46d4d0d2.svg";